import { checkJsonResult } from './util';

export const examination = body => fetch(
  '/api/examinations',
  {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    credentials: 'same-origin',
  },
).then(checkJsonResult);



// WEBPACK FOOTER //
// ./src/api/examination.js